import React from 'react';

const Input = ({
  className,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  ...rest
}) => {
  return (
    <input
      type={rest.type || 'text'}
      name={name}
      ref={inputRef}
      className={className}
      {...rest}
    />
  );
};

export default Input;
